import type { TStateAidFormValues } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/types.ts';
import { getStateAidQuarterWindow } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/stateAidReceived/quarterUtils.ts';

const STATE_AID_TEXT_FIELD_NAMES = [
  'apprAmountMmsp',
  'apprApplicationDateMmsp',
  'apprApprovalDateMmsp',
  'apprPlannedPeriodMmsp',
  'apprInstitutionMmsp',
  'apprAmountGroup',
  'apprApplicationDateGroup',
  'apprApprovalDateGroup',
  'apprPlannedPeriodGroup',
  'apprInstitutionGroup',
  'reqAmountMmsp',
  'reqApplicationDateMmsp',
  'reqInstitutionMmsp',
  'reqAmountGroup',
  'reqApplicationDateGroup',
  'reqInstitutionGroup',
  'covidAmountMmsp',
  'covidApplicationDateMmsp',
  'covidInstitutionMmsp',
  'covidAmountGroup',
  'covidApplicationDateGroup',
  'covidInstitutionGroup',
  'cultivatedArea',
  'signerPosition',
  'signerFullName',
] as const;

export const getDefaultStateAidFormValues = (
  yearPeriod?: string,
  childPeriod?: string
): TStateAidFormValues => {
  return {
    documentDate: new Date(),
    companyFullName: '',
    companyIdentifier: '',
    receivedAidQuarters: (getStateAidQuarterWindow(yearPeriod, childPeriod) ?? []).map(
      ({ year, quarter }) => ({
        year,
        quarter,
        amountMmsp: '',
        periodMmsp: '',
        institutionMmsp: '',
        amountGroup: '',
        periodGroup: '',
        institutionGroup: '',
      })
    ),
    ...Object.fromEntries(STATE_AID_TEXT_FIELD_NAMES.map((field) => [field, ''])),
    exportSales: false,
    idpStatus: false,
    veteranStatus: false,
    disabilityStatus: false,
    agricultural: false,
  } as TStateAidFormValues;
};
